/* eslint-disable import/no-anonymous-default-export */
import { SettingList } from './SettingList';
import { SettingEdit } from './SettingEdit';

export default {
  list: SettingList,
  edit: SettingEdit,
};
